import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { nativeRearCameraCapture } from "@/features/capture/lib/camera-capture";
import type { VariantProps } from "class-variance-authority";

export function NativeCameraButton({
  onPhoto,
  disabled,
  className,
  variant = "default",
  size = "xl",
  children,
}: {
  onPhoto: (file: File) => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
} & VariantProps<typeof buttonVariants>) {
  const attrs = nativeRearCameraCapture(typeof navigator === "undefined" ? "" : navigator.userAgent);
  return (
    <label
      className={cn(
        buttonVariants({ variant, size }),
        "relative",
        disabled && "pointer-events-none opacity-64",
        className,
      )}
    >
      <input
        type="file"
        accept={attrs.accept}
        capture={attrs.capture}
        disabled={disabled}
        className="absolute inset-0 z-10 cursor-pointer opacity-0"
        onChange={e => {
          const file = e.target.files?.[0];
          if (file) onPhoto(file);
          e.target.value = "";
        }}
      />
      {children}
    </label>
  );
}
